export default function buildDisabledMessage(tag) {
  const pipelineCount = tag.pipelineTagsAggregate.aggregate.count;

  if (pipelineCount === 0) {
    return null;
  }

  const label = pipelineCount === 1 ? '1 Pipeline' : `${pipelineCount} Pipelines`;
  return `Attached to ${label}`;
}
